import type { ReactNode } from 'react';

export const symbol_set_meal: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M100-360q-24.75 0-42.37-17.63Q40-395.25 40-420v-400q0-24.75 17.63-42.38Q75.25-880 100-880h760q24.75 0 42.38 17.62Q920-844.75 920-820v400q0 24.75-17.62 42.37Q884.75-360 860-360H100Zm0-460v400h760v-400H100Zm712 564-659 34q-13 1-22-7t-10-21q-1-13 7.5-22t21.5-10l659-34q13-1 22 7t10 21q1 13-7.5 22T812-256Zm-2 135H150q-13 0-21.5-8.5T120-151q0-13 8.5-21.5T150-181h660q13 0 21.5 8.5T840-151q0 13-8.5 21.5T810-121ZM419.73-510q70.94 0 136.6-24.5Q622-559 672-610q4 29 25.5 48.5T749-535q8 2 19.5 1.5T780-548v-144q0-14-11.5-14.5T749-705q-31 8-53 27t-25 49q-50.82-48.63-115.55-74.81Q490.72-730 419.76-730 344-730 284.5-707 225-684 172-630q-2 2-4 9.5 0 2.5 4 10.5 53 54 112.5 77t135.23 23ZM100-820v400-400Z"
		/>
	</svg>
);
